import { API } from "@/lib/api";
import { APIService } from "@/services/api";
import {
  ContractorPanelPlannedHoursAccept,
  ContractorPanelPlannedHoursStatus,
  ReadContractorPlannedHours,
} from "@/types/contractorPlannedHours";

const contractorPanelPlannedHoursService =
  new APIService<ReadContractorPlannedHours>(API.ContractorPanelPlannedHours);

export const ContractorPanelPlannedHoursService = {
  getStatus: () =>
    contractorPanelPlannedHoursService.get<ContractorPanelPlannedHoursStatus>(
      "status",
    ),
  accept: () =>
    contractorPanelPlannedHoursService.post<
      object,
      ContractorPanelPlannedHoursAccept
    >({}, "approve"),
};
